import nodeClient from "./node-client";
export const saveStockAuditProducts = async (formdata) => {
  const response = await nodeClient.post(
    `/service/private/v0/stock/audit/request/save`,
    formdata
  );
  return response?.data;
};

export const fetchStockTransferDetailsData = async (query) => {
  const response = await nodeClient.get(
    `/service/protected/v0/stock/transfer/findOne?${query}`,
  );
  return response?.data;
};

export const fetchStockRequestDetailsData = async (query) => {
  const response = await nodeClient.get(
    `/service/protected/v0/stock/request/findOne?${query}`,
  );
  return response?.data;
};